import { isFuture } from 'date-fns';

export function hasIncomeDocs(data) {
  if (!data) {
    return false;
  }

  return data.rentalListing.landlordRentalApplication.applicant.answers.currentIncomes
    .flatMap((currentIncome) => currentIncome.documents)
    .some((document) => isFuture(document.expirationDateTime));
}
